import { memo, useCallback } from 'react';

import { PrivateAudioSampleRatesSelect } from '~/components/Filters/AudioSampleRateFilter/components/PrivateAudioSampleRatesSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard, type StringArrayFilterCardProps } from '~/components/Filters/StringArrayFilterCard';

type PrivateAudioSampleRateFilterCardProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseFilterCardProps;

export const PrivateAudioSampleRateFilterCard = memo(
  ({ boardId, libraryId, ...props }: PrivateAudioSampleRateFilterCardProps) => {
    const renderAudioSampleRatesSelect = useCallback<StringArrayFilterCardProps['StringSelect']>(
      (props) => <PrivateAudioSampleRatesSelect libraryId={libraryId} boardId={boardId} {...props} />,
      [boardId, libraryId],
    );

    return (
      <StringArrayFilterCard
        filter="audioSampleRates"
        filterCardType="audioSampleRate"
        StringSelect={renderAudioSampleRatesSelect}
        {...props}
      />
    );
  },
);

PrivateAudioSampleRateFilterCard.displayName = 'PrivateAudioSampleRateFilterCard';
